import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { Lb4ApiService } from 'src/app/shared/service/api/lb4-api.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import * as moment from 'moment';
import { ActualFactureData, AppointmentFactureData } from './interface/appoint-task';
import { TranslateService } from '@ngx-translate/core';
import { CommonService } from 'src/app/shared/service/common/common.service';

@Component({
  selector: 'app-appoint-task',
  templateUrl: './appoint-task.component.html',
  styleUrls: ['./appoint-task.component.scss']
})
export class AppointTaskComponent implements OnInit {
  @Input() appointEditStatus: boolean = true;
  @Input() appAppointStatus: boolean = true;
  @Input() makeBudgetEstimatesStatus: boolean = false;
  @Input() editBudgetEstimatesStatus: boolean = false;
  @Input() reviewResultIsReject: boolean = false;
  @Input() electromechanical: boolean = false;
  @Input() civilEngineering: boolean = false;
  @Input() assignStatusData;
  @Input() formid: string;
  @Input() step: number = 3;
  @Input() activeBtn = "";
  @Output() submitAppointTaskDataEvent = new EventEmitter<object>();
  @Output() submitActualTaskDataEvent = new EventEmitter<object>();


  //  预约厂商查看现场与标单信息
  civilPreAppointmentData: Date | null = null;
  civilAfterAppointmentData: Date | null = null;
  elecPreAppointmentData: Date | null = null;
  elecAfterAppointmentData: Date | null = null;
  // 实际厂商查看现场与标单信息
  civilActualViewData: Date | null = null;
  elecActualViewData: Date | null = null;

  // 预约厂商查看现场与标单信息
  appointmentFactureData: AppointmentFactureData = {
    "appointmentManfacturerData": {
      "civilfactureData": {},
      "electrofactureData": {}
    }
  };
  // 实际厂商查看现场与标单信息
  actualFactureData: ActualFactureData = {
    "civilfactureData": {},
    "electrofactureData": {}
  };

  // 要求出标单天数
  appointmentDays = [2, 3, 4, 5, 6, 7, 8, 9, 10];

  // title
  bidtimeInfo = [];


  // 要提交的厂商到现场的实际时间信息
  submitActualTaskData = {
    "civil": {},
    "elec": {},
  }

  constructor(
    private message: NzMessageService,
    private lb4ApiService: Lb4ApiService,
    private translateService: TranslateService,
    private commonService: CommonService
  ) { }

  async ngOnInit(): Promise<void> {
    // 预约厂商查看现场与标单信息非编辑状态下才获取DB中的信息
    if (!this.appointEditStatus) {
      await this.getManufacturerTimeInfo();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['reviewResultIsReject'] !== undefined) {// 如果是点击驳回产生的change,则忽略,不用重新设置bidtime;否则会重复产生查看现场时间
      return;
    }
    this.bidtimeInfo = [];
    if (this.civilEngineering) {
      this.bidtimeInfo.push({ "text": this.translateService.instant('AppointVendor.CivilEngineeringVendor'), "value": "civilfactureData" });
    }
    if (this.electromechanical) {
      this.bidtimeInfo.push({ "text": this.translateService.instant('AppointVendor.ElectromechanicalVendor'), "value": "electrofactureData" });
    }
  }

  // 预约厂商查看现场与标单信息
  nzAppointSelectChanged(event: Date | string, dayType: string, value: string) {
    let data = this.appointmentFactureData.appointmentManfacturerData[value];
    if (event === null) {
      delete data[dayType];
      data['appointmentData'] = "";
    }
    else {
      // 要求出标单天数或日期
      data[dayType] = typeof event === 'number' ? event : moment(event).format("YYYY-MM-DD HH:mm")
      if ((data['preAppointmentData'] !== undefined && data['preAppointmentData'] !== null) && (data['appointmentDay'] !== undefined)) {
        // 须提供标单时间
        data['appointmentData'] = this.commonService.getWeekdaysEndDateTime(data['preAppointmentData'], data['appointmentDay']);
        // 厂商和formId
        this.appointmentFactureData.appointmentManfacturerData[value]['manufacturer'] = value === "civilfactureData" ? this.translateService.instant('AppointVendor.CivilEngineeringVendor') : this.translateService.instant('AppointVendor.ElectromechanicalVendor');
        this.appointmentFactureData.appointmentManfacturerData[value]['formId'] = this.formid;
      }
      if ((data['preAppointmentData'] !== undefined && data['preAppointmentData'] !== null) && (data['afterAppointmentData'] !== undefined && data['afterAppointmentData'] !== null)) {
        const overTimeOfMinutes = moment(data['afterAppointmentData']).diff(data['preAppointmentData'], "minutes");
        if (overTimeOfMinutes < 0) {
          this.message.create('error', this.translateService.instant('AppointVendor.AppointDateTip'));
        }
      }
    }
    // 将须提供标单时间展示在DOM中
    this.submitAppointTaskDataEvent.emit(this.appointmentFactureData);
  }

  /* 
    实际厂商查看现场与标单信息
    准时:实际查看现场时间 + 要求出标单天数 >= 实际提供标单时间
    超时:实际查看现场时间 + 要求出标单天数 < 实际提供标单时间
  */
  nztActualSelectChanged(event: Date | string, dayType: string, value: string) {
    let data = this.actualFactureData[value];
    if (event === null) {
      delete this.actualFactureData[value][dayType];
      this.actualFactureData[value]['overTime'] = null;
    }
    else {
      // 厂商实际查看现场时间
      data[dayType] = moment(event).format("YYYY-MM-DD HH:mm");
      // 实际提供标单时间:data['actualData']
      if (moment(data['actualData']).isBefore(data[dayType])) {
        this.message.create('error', this.translateService.instant('AppointVendor.ActualDateTip'));
      }
      else {
        // 预计厂商提供标单时间(expectedProvidData = 厂商实际查看现场时间 + 间隔数)
        const expectedProvidData = this.commonService.getWeekdaysEndDateTime(data[dayType], this.appointmentFactureData.appointmentManfacturerData[value]['appointmentDay']);

        const overTimeOfMinutes = moment(data['actualData']).diff(expectedProvidData, "minutes");// 间隔天数不包括周末;间隔小时数 = 厂商实际提供标单时间 - 预计厂商提供标单时间;
        const overTime = Number((overTimeOfMinutes / 60).toFixed(2));
        this.actualFactureData[value]['overTime'] = overTime;
      }
      this.submitActualTaskDataEvent.emit(this.actualFactureData);
    }
  }

  // 获取DB中的预约厂商的数据
  async getManufacturerTimeInfo() {
    await this.lb4ApiService.find(
      'appointment_manufacturer_time',
      { order: 'id DESC', where: { "formId": this.formid } }).then(res => {
        if (res.length > 0) {
          for (const each of res) {
            let civilOrElec = each['civilOrElectro'] === 0 ? "civilfactureData" : "electrofactureData";
            if (!!civilOrElec) {
              this.appointmentFactureData.appointmentManfacturerData[civilOrElec]['preAppointmentData'] = each['preAppointmentData'];
              this.appointmentFactureData.appointmentManfacturerData[civilOrElec]['afterAppointmentData'] = each['afterAppointmentData'];
              this.appointmentFactureData.appointmentManfacturerData[civilOrElec]['appointmentDay'] = each['appointmentDay'];
              this.appointmentFactureData.appointmentManfacturerData[civilOrElec]['appointmentData'] = each['appointmentData'];
              this.getCivilOrElecDate(each, civilOrElec);
            }
          }
        }
      })
      .catch(e => {
        this.message.create('error', `${this.translateService.instant('CommonMessageTip.getDataFail')}`);
      });
  }

  getCivilOrElecDate(each: object, civilOrElec: string) {
    if (!!(each['actualData'])) {
      // 实际提供标单时间
      this.actualFactureData[civilOrElec]['actualData'] = moment(each['actualData']).format("YYYY-MM-DD HH:mm");
    }
    // 厂务概算制定--已制定/已驳回
    if (this.activeBtn !== 'Common.ToBeCreated') {
      // 实际厂商查看现场时间
      if (!!(each['actualViewData'])) {
        // 已驳回
        if (civilOrElec === 'civilfactureData') {
          this.civilActualViewData = new Date(each['actualViewData']);
        }
        else {
          this.elecActualViewData = new Date(each['actualViewData']);
        }
        this.nztActualSelectChanged(new Date(each['actualViewData']), 'actualViewData', civilOrElec);
        // 已制定
        this.actualFactureData[civilOrElec]['actualViewData'] = moment(each['actualViewData']).format("YYYY-MM-DD HH:mm");
      }
      if (!!(each['actualData']) && !!(each['actualViewData'])) {
        const expectedProvidData = this.commonService.getWeekdaysEndDateTime(each['actualViewData'], each['appointmentDay']);
        // 间隔小时数 = 厂商实际提供标单时间 - 预计厂商提供标单时间
        const overTimeOfMinutes = moment(each['actualData']).diff(expectedProvidData, "minutes");
        const overTime = Number((overTimeOfMinutes / 60).toFixed(2));
        this.actualFactureData[civilOrElec]['overTime'] = overTime;
      }
    }
  }
}
